import {useState} from "react";
import stl from "./LimitedAvaInfoBox.module.css";
import {useTranslation} from "@i18n";
import {CDN_LINK} from "@globalConfig";
import loadable from "@loadable/component";


const fallback = {
  fallback: "Loading...",
};
const BottomSheetPopup = loadable(() =>
      import("@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup"),
    fallback
);
const LimitedAvaInfoBox = () => {
  const {t} = useTranslation();
  const [showPopUp, setShowPopUp] = useState(false);

  return (
    <>
      <div className={stl.infoFlex}>
        <div className={`${stl.infoContainer}`}>
          <img src={CDN_LINK + "/assets/images/limited_warning_icon.svg"} alt="w" />
          <div className={stl.text}>
            <p>{t("هذه السيارة غير متوفرة حالياً", { ns: "web_post_view" })}</p>
            <div className={stl.flex}>
              <p>
                {t("احجزها الآن حتى نتمكن من توفيرها لك خلال أسبوعين", {
                  ns: "web_post_view",
                })}
              </p>
              <p
                onClick={() => {
                  setShowPopUp(true);
                }}
              >
                {t("اعرف اكثر", { ns: "web_post_view" })}
              </p>
            </div>
          </div>
        </div>
      </div>

      {showPopUp && <BottomSheetPopup
          show={showPopUp}
          onClose={() => setShowPopUp(false)}
          className={stl.customPopUp}
      >
        <div className={stl.popupContainer}>
          <h3> {t("تنويه بخصوص توفر السيارة", { ns: "web_post_view" })}</h3>
          <ul>
            <li>
              {t(
                  "هذه السيارة غير متوفرة حالياً، وسيعمل فريقنا على توفيرها والتواصل معك خلال أسبوعين",
                  { ns: "web_post_view" }
              )}
            </li>
            <li>
              {" "}
              {t("في حال عدم توفرها سيتم التواصل معك", { ns: "web_post_view" })}
            </li>
            <li>
              {" "}
              {t(
                  "يمكنك استرداد العربون في حال عدم تمكننا من توفير السيارة أو إلغاء الطلب",
                  { ns: "web_post_view" }
              )}
            </li>
            <li>
              {" "}
              {t(
                  "سعر السيارة غير نهائي ويمكن أن يتغير حسب توفر السيارة في السوق",
                  { ns: "web_post_view" }
              )}
            </li>
          </ul>
        </div>
      </BottomSheetPopup>}

    </>
  );
};

export default LimitedAvaInfoBox;
